'use strict';

import controller from './dbc.controller';
import template from './dbc.html';

const dbcComponent = {
  bindings: {
    proyecto: '=',
    modoVista: '<'
  },
  controller,
  template
};

export default dbcComponent;



// WEBPACK FOOTER //
// ./src/app/components/proyectos/c-proyectos/dbc/dbc.component.js